import React from 'react'

import {QueryStatus} from '../../containers/QueryBuilder/types/Query'
import {Skeleton, Col, Row, Divider, Button} from "antd"
import {BarChartOutlined, Loading3QuartersOutlined, TableOutlined} from "@ant-design/icons"

import styles from './QueryBuilderResultsSkeleton.module.scss'

export type QueryBuilderResultsSkeletonProps = {
    queryStatus: QueryStatus
    isCohortAnalyser: boolean
}

export const QueryBuilderResultsSkeleton = ({queryStatus, isCohortAnalyser}: QueryBuilderResultsSkeletonProps) => {

    const isFinished = queryStatus === QueryStatus.FINISHED
    const queryStatusMessage = isFinished ? 'Query Loading' : 'Query Running'

    return (
        <div data-testid = 'query-skeleton'>
            <div className={styles.queryStatusMessage}>
                <span className={isFinished? styles.queryLoadingText : styles.queryProcessingText}>{queryStatusMessage}</span>
            </div>

            <div className={styles.centerAlign}>
                <span className={styles.queryLoadingIndicator}><Loading3QuartersOutlined spin/></span>
            </div>

            <div className={styles.skeletonText}>
                You can switch between query <strong>results</strong> and <strong>visualizations</strong> when this is complete<br/>
                <Button className={styles.tabButton}>{isCohortAnalyser ? 'Cohort Analyser' : 'Query Builder'}</Button>
                <Button className={styles.tabButton}>Query Visualizer</Button>
            </div>

            <Row className={styles.skeletonRow} justify={'center'} align={'stretch'} gutter={[16, 24]}>
                <Col span={4}>
                    <Skeleton.Node active>
                        <TableOutlined className={styles.skeletonIcon}/>
                    </Skeleton.Node>
                </Col>
                <Col className={styles.dividerColumn} span={2}>
                    <Divider type='vertical' className={styles.divider}/>
                </Col>
                <Col span={4}>
                    <Skeleton.Node active>
                        <BarChartOutlined className={styles.skeletonIcon}/>
                    </Skeleton.Node>
                </Col>
            </Row>

            <Row justify={'center'} align={'stretch'} gutter={[16, 24]}>
                <Col span={4}>
                    <Skeleton active/>
                </Col>
                <Col className={styles.dividerColumn} span={2}>
                    <Divider className={styles.divider} type='vertical'/>
                </Col>
                <Col span={4}>
                    <Skeleton active/>
                </Col>
            </Row>
        </div>
    )
}